import { loadable } from 'nordic/lazy';
import headCompats from './head.compats';

const CompatsMessageFeedabak = loadable(() => import('../../../../components/compats-widget/message-feedback'));

export default headCompats(CompatsMessageFeedabak);
